import { trackEvent } from './utils/analytics'

export function init() {
  $('[data-search-form]').on('submit', function (event) {
    const $form = $(this)
    const form = $form.serializeArray()
    const query = form[0].value || ''
    if (query) {
      trackEvent('Toolbox', 'Search', query)
      return true
    } else {
      event.preventDefault()
      return false
    }
  })
}
